"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.severityToColorsLight = exports.severityToColorsDark = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styles_1 = require("@mui/material/styles");
const Tag_1 = tslib_1.__importDefault(require("@mnemonic/mui5/Tag"));
const capitalizeFirstLetter_1 = require("../_InternalUtils/capitalizeFirstLetter");
const styles_2 = require("../styles");
/**
 * This component displays a tag to indicate the severity level, with colors matching the specified level.
 * Defaults to predefined text for each level, with an option to add custom text.
 * Levels include "low," "medium," "high," "critical," and "none."
 *
 * @category component
 */
const SeverityTag = (props) => {
    const theme = (0, styles_1.useTheme)();
    const isDarkMode = (0, styles_2.useIsDarkMode)();
    const { severity, toText, ...TagProps } = props;
    const { toText: defaultToText } = (0, styles_1.useThemeProps)({
        props,
        name: "SeverityTag",
    });
    const colors = isDarkMode ? (0, exports.severityToColorsDark)(theme, severity) : (0, exports.severityToColorsLight)(theme, severity);
    return (react_1.default.createElement(Tag_1.default, { backgroundColor: colors.backgroundColor, fontColor: colors.color, maxHeight: 24, text: toText ? (0, capitalizeFirstLetter_1.capitalizeFirstLetter)(toText(severity)) : (0, capitalizeFirstLetter_1.capitalizeFirstLetter)(defaultToText(severity)), typographyProps: {
            style: {
                alignItems: "center",
                display: "flex",
                height: "24px",
                justifyContent: "center",
                width: "72px",
            },
            variant: "subtitle2",
        }, ...TagProps }));
};
const severityToColorsDark = (theme, severity) => ({
    color: "black",
    backgroundColor: severity === "none" ? "lightgrey" : theme.palette.criticality?.[severity]?.main,
});
exports.severityToColorsDark = severityToColorsDark;
const severityToColorsLight = (theme, severity) => ({
    color: "inherit",
    backgroundColor: severity === "none" ? "lightgrey" : theme.palette.criticality?.[severity]?.light,
});
exports.severityToColorsLight = severityToColorsLight;
exports.default = SeverityTag;
